module.exports = __webpack_public_path__ + "static/media/corp_build.8c0262d3.jpg";